import { render } from "./MemberLeftNav.vue?vue&type=template&id=e5f2dcfe&scoped=true"
import script from "./MemberLeftNav.vue?vue&type=script&lang=js"
export * from "./MemberLeftNav.vue?vue&type=script&lang=js"

import "./MemberLeftNav.vue?vue&type=style&index=0&id=e5f2dcfe&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f2dcfe"]])

export default __exports__